import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import RecommendedSection from './components/RecommendedSection';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <RecommendedSection />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
              韩漫网 - 你的韩漫阅读乐园
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-6">
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-500">3000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">韩漫作品</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">500万+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">月活跃读者</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-500">98%</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">读者好评率</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">全天候</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">免费阅读</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫网',
            url: 'https://www.hanmanweb.com/',
            description: siteInfo.description,
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.hanmanweb.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫网',
            url: 'https://www.hanmanweb.com/',
            description: siteInfo.description,
            email: siteInfo.email,
            foundingDate: siteInfo.founded,
          }),
        }}
      />
    </>
  );
}